import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import InfoCircleTooltip from 'components/atoms/GefMui/InfoCircleTooltip';
import { codelists } from 'constants/codelists';
import { notificationSetIds } from 'features/views/settings/constants';
import { getSwitchDescription } from 'features/views/settings/utils';
import { getCodelistByName } from 'utils';

import SettingsSwitch from './SettingsSwitch';

const { LOSS_CLIENT_SME_TASKS_REPORT } = notificationSetIds;

export const LossClientSMETasksReport = () => {
	const notificationsSetCodelist = useSelector(getCodelistByName(codelists.notificationsSet));

	const getSwitchShortDescription = getSwitchDescription(notificationsSetCodelist);

	const settingsHeader = (
		<Stack
			spacing={1}
			direction="row"
			sx={{
				alignItems: 'center',
			}}
		>
			<Typography variant="h5" color="text.primary">
				{getLabelMessage('settings:lossClientSMETasksReport')}
			</Typography>
			<InfoCircleTooltip text={getLabelMessage('settings:lossClientSMETasksReportTooltip')} />
		</Stack>
	);

	return (
		<Grid size={12}>
			<Grid container>
				<Grid size={12}>{settingsHeader}</Grid>
				<Grid size={12}>
					<Grid container>
						<Grid size={12}>
							<SettingsSwitch
								description={getSwitchShortDescription(LOSS_CLIENT_SME_TASKS_REPORT)}
								notificationSetId={LOSS_CLIENT_SME_TASKS_REPORT}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LossClientSMETasksReport;
